import React from "react";
import styles from "./Logos.module.scss";
import { LogosType } from "@/types/OptionType";
import { SVGIcon } from "../../SVGIcon/SVGIcon";
import { passACFLink } from "@/utils/passACFLink";
import { CustomLink } from "@/components/CustomLink";

interface LogosProps {
  logos: LogosType[];
}

const Logos = React.memo(
  ({ logos }: LogosProps) => {
    const Logo = ({ logo }: { logo: LogosType }) => {
      const logoJSX = logo.logo_positive && (
        <SVGIcon
          width={"auto"}
          height={"100%"}
          src={logo.logo_positive.url}
          priority={true}
          alt={logo.logo_positive.alt}
        />
      );
      return (
        <li className={styles["logo"]}>
          {logo.link ? (
            <CustomLink
              className={styles["link"]}
              {...passACFLink(logo, "link")}
            >
              {logoJSX}
            </CustomLink>
          ) : (
            logoJSX
          )}
        </li>
      );
    };

    return (
      <ul className={styles["logos"]}>
        {logos.map((logo, key) => {
          return <Logo key={key} logo={logo} />;
        })}
      </ul>
    );
  },
  (prevProps, nextProps) => {
    // Perform a shallow comparison of the `logos` array
    return prevProps.logos === nextProps.logos;
  },
);

Logos.displayName = "Logos";

export { Logos };

// import styles from "./Logos.module.scss";
// import { CustomLink } from "../../Global/CustomLink";
// import { LogosType } from "../../../utils/types/OptionType";
// import { SVGIcon } from "../../SVGIcon/SVGIcon";
// import { passACFLink } from "@/utils/passACFLink";

// interface LogosProps {
//   logos: LogosType[];
// }

// export const Logos = ({ logos }: LogosProps) => {
//   const Logo = ({ logo }: { logo: LogosType }) => {
//     const logoJSX = logo.logo_positive && (
//       <SVGIcon
//         width={"auto"}
//         height={"100%"}
//         src={logo.logo_positive.url}
//         priority={true}
//         alt={logo.logo_positive.alt}
//       />
//     );
//     return (
//       <li className={styles["logo"]}>
//         {logo.link ? (
//           <CustomLink className={styles["link"]} {...passACFLink(logo, "link")}>
//             {logoJSX}
//           </CustomLink>
//         ) : (
//           logoJSX
//         )}
//       </li>
//     );
//   };

//   return (
//     <ul className={styles["logos"]}>
//       {logos.map((logo, key) => {
//         return <Logo key={key} logo={logo} />;
//       })}
//     </ul>
//   );
// };
